/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { agentMemoryControllerCreate } from "./agentMemoryControllerCreate";
import { agentMemoryControllerFindAll } from "./agentMemoryControllerFindAll";
import { agentMemoryControllerUpdate } from "./agentMemoryControllerUpdate";

export function agentMemoriesService() {
  return { agentMemoryControllerFindAll, agentMemoryControllerCreate, agentMemoryControllerUpdate }
}